// =======================
//         COMMON
// =======================
export var Products;
(function (Products) {
    Products["JuniorApp"] = "junior_app";
    Products["ABCApp"] = "abc_app";
})(Products || (Products = {}));
export var EventCategory;
(function (EventCategory) {
    EventCategory["Audio"] = "audio";
    EventCategory["Exercise"] = "exercise";
    EventCategory["Authentication"] = "authentication";
    EventCategory["Achievements"] = "achievements";
    EventCategory["Popup"] = "popup";
    EventCategory["Onboarding"] = "onboarding";
    EventCategory["Theory"] = "theory";
    EventCategory["Data"] = "data";
})(EventCategory || (EventCategory = {}));
export var EventName;
(function (EventName) {
    EventName["ABCAnnouncementPopup"] = "abc_announcement_popup";
    EventName["ABCStorylineIntro"] = "abc_storyline_intro";
    EventName["ABCBookWormSelect"] = "abc_book_worm_select";
    EventName["ABCBookStorySelect"] = "abc_book_story_select";
    EventName["ABCExerciseFinished"] = "exercise_finished";
    EventName["ABCBlockStarted"] = "block_started";
    EventName["ABCBlockFinished"] = "block_finished";
    EventName["AccountWarning"] = "account_warning";
    EventName["AddChild"] = "add_child";
    EventName["AppRatePopup"] = "app-rate-popup";
    EventName["AndroidStoragePermissionGranted"] = "android_storage_permission_granted";
    EventName["AndroidStoragePermissionDeclined"] = "android_storage_permission_declined";
    EventName["BlockFinished"] = "BlockFinished";
    EventName["BlockSelect"] = "block-select";
    EventName["BlockStarted"] = "block-started";
    EventName["BookSelect"] = "book_select";
    EventName["BossFightExited"] = "bossfight_exited";
    EventName["BossFightFinished"] = "bossfight_finished";
    EventName["BossFightPlayAgain"] = "bossfight_play_again";
    EventName["ComicClosed"] = "comic_closed";
    EventName["ComicGoBack"] = "comic_go_back";
    EventName["ComicGoNext"] = "comic_go_next";
    EventName["EventRewardAcquired"] = "event_reward_acquired";
    EventName["ExerciseFinished"] = "exercise-finished";
    EventName["ExerciseSelect"] = "exercise-select";
    EventName["ExerciseRewardPopup"] = "exercise_reward_popup";
    EventName["FaqExpanded"] = "faq_expanded";
    EventName["GoBack"] = "go_back";
    EventName["GoNext"] = "go_next";
    EventName["GoToPortal"] = "go_to_portal";
    EventName["GoToTop"] = "go_to_top";
    EventName["HouseSelect"] = "house_select";
    EventName["LessonClosed"] = "lesson_closed";
    EventName["LessonsAndComicsPopup"] = "lessons_and_comics_popup";
    EventName["LoginRewardPopup"] = "login_reward_popup";
    EventName["WisdomSwordPopup"] = "wisdom_sword_popup";
    EventName["LevelFinished"] = "level_finished";
    EventName["LevelSelect"] = "level-select";
    EventName["LevelStarted"] = "level_started";
    EventName["LoginJunior"] = "login_junior";
    EventName["LogoutJunior"] = "logout_junior";
    EventName["MilestoneBlockFinished"] = "block-finished";
    EventName["MiniGameFinished"] = "mini_game_finished";
    EventName["MiniGameSkipped"] = "mini_game_skipped";
    EventName["MuteAudio"] = "mute-audio";
    EventName["OnboardingCompleted"] = "onboarding-completed";
    EventName["PhotoRemoved"] = "photo_removed";
    EventName["PhotoTaken"] = "photo_taken";
    EventName["PlayAudio"] = "play-audio";
    EventName["ProductSelected"] = "product_selected";
    EventName["ProfileSettingsClosed"] = "profile_settings_closed";
    EventName["ProfileSettingsSelect"] = "profile_settings_select";
    EventName["SeasonAnnouncementPopup"] = "season_announcement_popup";
    EventName["SectionFinished"] = "section-finished";
    EventName["SectionStarted"] = "section-started";
    EventName["SetupChildAccountPopup"] = "setup_child_account_popup";
    EventName["ShopSelect"] = "shop_select";
    EventName["SoundToggle"] = "sound_toggle";
    EventName["StorylineIntroSelect"] = "storyline_intro_select";
    EventName["SubmitAnswer"] = "Submit answer";
    EventName["SwitchUserClick"] = "switch_user_click";
    EventName["SwordChanged"] = "sword_changed";
    EventName["SwordPurchased"] = "sword_purchased";
    EventName["SwordSelect"] = "sword_select";
    EventName["TTSToggle"] = "TTS_toggle";
    EventName["TrophyEarned"] = "trophy-earned";
    EventName["UnmuteAudio"] = "unmute-audio";
    EventName["UserSwitched"] = "user_switched";
    EventName["BillingPeriodSwitched"] = "junior_billing_period_switched";
    EventName["CinemaSelected"] = "junior_cinema_selected";
    EventName["CinemaLuckyButtonSelected"] = "junior_cinema_lucky_btn_selected";
    EventName["CinemaVideoSelected"] = "junior_cinema_video_selected";
    EventName["CinemaVideoClosed"] = "junior_cinema_video_closed";
    EventName["CinemaVideoFinished"] = "junior_cinema_video_finished";
    EventName["ParentControlGuideOpen"] = "junior_parent_control_guide_open";
    EventName["ParentControlGuideLinkCopied"] = "junior_parent_control_link_copied";
    EventName["JuniorLevelUp"] = "junior_level_up";
    EventName["JuniorContentLoaded"] = "junior_content_loaded";
    EventName["JuniorLevelFinished"] = "junior_level_finished";
    EventName["JuniorCinemaToggled"] = "junior_cinema_toggled";
})(EventName || (EventName = {}));
// TODO(charlieroth): duplicate from app but should be pulled into albert-common??
var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["Active"] = "active";
    SubscriptionStatus["Trialing"] = "trialing";
    SubscriptionStatus["Churned"] = "canceled";
})(SubscriptionStatus || (SubscriptionStatus = {}));
//# sourceMappingURL=juniorAnalytics.js.map